/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_SanctionedInputs */



/**
* | output |
* | --- |
* | "Sanctioned" |
*
* @param {User_List_Filter_SanctionedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_sanctioned = /** @type {((inputs?: User_List_Filter_SanctionedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_SanctionedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sanctionné")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sancionados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sancionados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sanzionati")
	return /** @type {LocalizedString} */ ("Sanctioned")
});